<template>
    <footer class="bg-zinc-900 mt-6" aria-labelledby="footer-heading">
        <!-- <h2 id="footer-heading" class="sr-only">Footer</h2>
        <div class="mx-auto max-w-7xl w-full">
            <div class="border-t border-gray-900/10 md:flex md:items-center md:justify-between"></div>
            <div class="mx-auto mt-12 items-center justify-between">
                <AppLogo />
            </div>
            <div class="grid grid-cols-2 gap-8">
                <div class="block">
                    <div class="pt-4 pr-6">
                        <p class="text-sm leading-6 text-white">
                            Requests for credit submitted on this website may be originated by one of several Bank
                            Lending Partners, including: Member FDIC and First Electronic Bank, Member FDIC.
                        </p>
                    </div>
                    <div class="pt-4 pr-6">
                        <p class="text-sm leading-6 text-white">
                            Our Bank Lending Partners reserve the right to assess your creditworthiness and ability to
                            pay periodically, which may impact how you use your Line of Credit.
                        </p>
                    </div>
                    <div class="pt-4 pr-6">
                        <p class="text-sm leading-6 text-white">
                            A Line of Credit through {{ $root.app.name }} is an expensive form of credit and should not
                            be used as a long-term financial solution.
                        </p>
                    </div>
                    <div class="pt-4 pr-6">
                        <p class="text-sm leading-6 text-white">
                            1 Not all requests are approved; duration of approval process may vary. Credit limits may
                            vary and are subject to verification criteria.
                        </p>
                    </div>
                    <div class="pt-4 pr-6">
                        <p class="text-sm leading-6 text-white">
                            2 The exact impact of payment(s) and/or account activity on your Line of Credit through
                            {{ $root.app.name }} to your credit score is unknown as your credit score is influenced by
                            numerous contributing factors.
                        </p>
                    </div>
                    <div class="pt-4 pr-6">
                        <p class="text-sm leading-6 text-white">
                            3 If approved, any requested funds will typically be deposited into your bank account the
                            same business day; timing of funding may vary. The date and time the funds are made
                            available to you by your bank are subject to your bank’s policies. For specific funding
                            cut-off times, click here.
                        </p>
                    </div>
                    <div class="pt-4 pr-6">
                        <p class="text-sm leading-6 text-white">
                            4 If you have an upcoming due date and would like to set up an Automated Clearing House
                            (ACH) payment, your request must be received by 6:00 PM ET one (1) business day before your
                            due date. Processing of payments are subject to your bank’s policies.
                        </p>
                    </div>
                    <div class="pt-4 pr-6">
                        <p class="text-sm leading-6 text-white">
                            5 As you move through your credit journey, your account may become eligible for reduced
                            billing cycle charges and/or increased credit limits based on a good payment history over
                            time. You will receive notices, as applicable, regarding your individual circumstances and
                            eligibility. Eligibility varies by state.
                        </p>
                    </div>
                </div>
                <div class="grid grid-cols-3 gap-8">
                    <div>
                        <h3 class="text-sm font-semibold leading-6 text-white">Site Links</h3>
                        <ul role="list" class="mt-6 space-y-4">
                            <li>
                                <a class="text-sm leading-6 text-white hover:text-gray-900 no-underline"
                                    >How it Works</a
                                >
                            </li>
                            <li>
                                <a class="text-sm leading-6 text-white hover:text-gray-900 no-underline"
                                    >Cost of Credit</a
                                >
                            </li>
                            <li>
                                <a class="text-sm leading-6 text-white hover:text-gray-900 no-underline">Lenders</a>
                            </li>
                            <li>
                                <a class="text-sm leading-6 text-white hover:text-gray-900 no-underline">Resources</a>
                            </li>
                            <li>
                                <a class="text-sm leading-6 text-white hover:text-gray-900 no-underline">FAQs</a>
                            </li>
                            <li>
                                <a class="text-sm leading-6 text-white hover:text-gray-900 no-underline">Money 101</a>
                            </li>
                            <li>
                                <a class="text-sm leading-6 text-white hover:text-gray-900 no-underline">Contact</a>
                            </li>
                            <button
                                type="submit"
                                class="text-white mx-2 no-underline font-medium pt-2 pb-2 px-3 border border-gray-50 rounded"
                            >
                                States
                            </button>
                        </ul>
                    </div>

                    <div>
                        <h3 class="text-sm font-semibold leading-6 text-white">Resources</h3>
                        <ul role="list" class="mt-6 space-y-4">
                            <li>
                                <a class="text-sm leading-6 text-white hover:text-gray-900 no-underline"
                                    >Account Login</a
                                >
                            </li>
                            <li>
                                <a class="text-sm leading-6 text-white hover:text-gray-900 no-underline">Apply Now</a>
                            </li>
                            <li>
                                <a class="text-sm leading-6 text-white hover:text-gray-900 no-underline">Legal</a>
                            </li>
                            <li>
                                <a class="text-sm leading-6 text-white hover:text-gray-900 no-underline"
                                    >Privacy Notices</a
                                >
                            </li>
                            <div class="border-t border-white w-full"></div>
                            <li>
                                <a class="text-sm leading-6 text-white hover:text-gray-900 no-underline"
                                    >Understanding a Line of Credit</a
                                >
                            </li>
                            <li>
                                <a class="text-sm leading-6 text-white hover:text-gray-900 no-underline"
                                    >All About Online Loans</a
                                >
                            </li>
                            <li>
                                <a class="text-sm leading-6 text-white hover:text-gray-900 no-underline"
                                    >Online Personal Loans</a
                                >
                            </li>
                        </ul>
                    </div>
                    <div>
                        <ul role="list" class="mt-6 space-y-4">
                            <button
                                type="submit"
                                class="text-white mx-2 no-underline font-medium pt-2 pb-2 px-3 border border-gray-50 rounded"
                            >
                                States
                            </button>
                            <li>
                                <a class="text-sm leading-6 text-white hover:text-gray-900 no-underline"
                                    >Online Personal Loans</a
                                >
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="border-gray-900/10 border-t md:flex md:items-center md:justify-between mt-10 pt-4">
                <p class="mt-8 text-xs leading-5 text-white md:order-1 md:mt-0">
                    Copyright &copy; 2023 Event Planner. All Rights Reserved.
                </p>
            </div>
        </div> -->
    </footer>
</template>

<script>
import AppLogo from "./../../../components/AppLogo";

export default {
    components: {
        AppLogo,
    },
};
</script>
